import {
    Button,
    Col, message,
    Row,
} from "antd";

import {AppPageHeader} from "components/AppPageHeader";
import {useAppSelector} from "hooks/useAppSelector";
import {useDocumentTitle} from "hooks/usePageTitle";
import React, {useEffect} from "react";
import {useAppDispatch} from "../../hooks/useAppDispatch";
import {genaratePpdSequence} from "../../store/ppd/ppdSlice";

const MESSAGE_KEY = "GENERATE_SEQUENCE";
export const GenerateSequencePage = () => {
    useDocumentTitle("Generate-Sequence");
    const {status, error} = useAppSelector(
        (state) => state.ppd
    );
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (status === "loading") {
            message.loading({content: "Generating Sequence", key: MESSAGE_KEY});
        } else if (status === "success") {
            message.success({
                content: "Sequence Generated Success",
                duration: 5,
                key: MESSAGE_KEY,
            });
        } else if (status === "error") {
            message.error({content: error, key: MESSAGE_KEY});
        }
    }, [status, error]);

    const handleButtonClick = async () => {
        dispatch(genaratePpdSequence({ isManualCall: true }));
    }

    return (
        <>
            <Row>
                <Col>
                    <AppPageHeader title="Generate PPD Sequence"/>
                </Col>
            </Row>
            <Row>
                <Button
                    type="primary"
                    onClick={handleButtonClick}
                    disabled={status === "loading"}
                    loading={status === "loading"}
                    >
                    Generate PPD Sequence
                </Button>
            </Row>
        </>
    );
};
